import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Homepage from './pages/Homepage';
import Company from './pages/Company';
import ProjectReferences from './pages/ProjectReferences';
import InvestmentProducts from './pages/InvestmentProducts';
import Footer from './components/Footer';
import ContactPage from './pages/ContactPage';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import CookieConsent from './components/CookieConsent';
import './styles/App.css';
import QuickLinks from './components/QuickLinks';
import ScrollRail from './components/ScrollRail';
import ScrollToTop from './components/ScrollToTop';
import ProjectTU from './pages/PorjectTU';
import ProjectSM from './pages/PorjectSM';
import ProjectKO from './pages/PorjectKO';
import ProjectJE from './pages/PorjectJE';
import NotFound from './pages/NotFound';
import ProjectMB91 from './pages/PorjectMB91';

const App: React.FC = () => {
  return (
    <Router>
      <Layout />
    </Router>
  );
};

const Layout: React.FC = () => {
  const location = useLocation();

  const hideQuickLinksRoutes = ['/kontakt', '/datenschutz', '/impressum']; 
  const shouldHideQuickLinks = hideQuickLinksRoutes.includes(location.pathname) || !['/', '/unternehmen', '/referenzen', '/investmentansatz', '/project-tu', '/project-sm', '/project-je', '/project-ko', '/project-mb91'].includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      <div className="app-container">
        <Header />
        {<ScrollRail />}
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/project-tu" element={<ProjectTU />} />
            <Route path="/project-sm" element={<ProjectSM />} />
            <Route path="/project-je" element={<ProjectJE />} />
            <Route path="/project-ko" element={<ProjectKO />} />
            <Route path="/project-mb91" element={<ProjectMB91 />} />
            <Route path="/unternehmen" element={<Company />} />
            <Route path="/referenzen" element={<ProjectReferences />} />
            <Route path="/investmentansatz" element={<InvestmentProducts />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        {!shouldHideQuickLinks && <QuickLinks />}
        <Footer />
      </div>
      <CookieConsent />
    </>
  );
};

export default App;
